import React from "react";
import "../../styles/respNetbilling.scss"
import { decode_utf8, getSignedIdStatus, changeDataFormat, getCurrentTime } from "../../../../common/utils/utilsFunc"
import HeaderSearch from "../../../../common/components/HeaderSearch";
import AttachedTicketNetBilling from "../AttachedTicketNetBilling"
import NetbillingContextProvider, {
    NetbillingContext,
    ACTIONS,
} from "../../context/NetbillingContextProvider";
import LastTickets from "../LastTickets";
import { LiferayService } from '../../../../common/services/liferay'
import Loading from "../../../../common/components/Loading";
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";

function AttachedTicketNetBillingController({ props }) {
    const [dataChart, setDataChart] = React.useState([]);
    const [dataItemTicket, setDataItemTicket] = React.useState({});
    const [inputSearch, setInputSearch] = React.useState("");
    const [inputSelected, setInputSelected] = React.useState("");
    const [labelsChart, setLabelsChart] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [loadingCount, setLoadingCount] = React.useState(0);
    const [state, dispatch] = React.useContext(NetbillingContext);
    const [showChart, setShowChart] = React.useState(false);
    const [urlBol, setUrlBol] = React.useState("");
    const [listTickets, setListTickets] = React.useState([])
    const data = state.idList ? state.idList : [];
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => setVisibleModal(false),
    });

    React.useEffect(() => {
        if (inputSearch !== "") {
            if (data.find((id) => id === inputSearch)) {
                setInputSelected(inputSearch);
                document.getElementById("mySelectId").value = inputSearch;
            }
        }
    }, [inputSearch]);

    React.useEffect(() => {
        if (inputSelected !== "") {
            setLoading(true);
            setInputSearch("");
            setUrlBol("");

            dispatch({
                payload: inputSelected,
                type: ACTIONS.SET_IDCTACTO,
            });

        } else {
            setInputSelected("");

            dispatch({
                payload: 0,
                type: ACTIONS.SET_IDCTACTO,
            });
        }
    }, [inputSelected]);

    React.useEffect(() => {
        if (state.idCtaCto) {
            sessionStorage.setItem("stateBoletaNetbillingPage", JSON.stringify(state));
        }
    }, [state]);

    React.useEffect(() => {
        const storedState = JSON.parse(sessionStorage.getItem("stateBoletaNetbillingPage"));
        if (storedState && storedState.idCtaCto !== 0) {
            setInputSelected(storedState.idCtaCto)
            dispatch({
                payload: storedState.idCtaCto,
                type: ACTIONS.SET_IDCTACTO,
            })
            dispatch({
                payload: storedState.resumeTicket,
                type: ACTIONS.SET_RESUME_TICKET,
            })
            dispatch({
                payload: storedState.loadPage,
                type: ACTIONS.SET_LOAD_PAGE,
            })
            dispatch({
                payload: storedState.idList,
                type: ACTIONS.SET_IDLIST,
            })
            dispatch({
                payload: storedState.historyConsu,
                type: ACTIONS.SET_HISTORY_CONSU,
            })
            dispatch({
                payload: storedState.listTickets,
                type: ACTIONS.SET_LIST_TICKETS,
            })
            dispatch({
                payload: storedState.responseDoc,
                type: ACTIONS.SET_RESPONSE_DOC,
            })
            dispatch({
                payload: storedState.responseDetailTicketPDF,
                type: ACTIONS.SET_RESPONSE_DETAIL_TICKET_PDF,
            })
            dispatch({
                payload: storedState.errorFetch,
                type: ACTIONS.SET_ERROR,
            })
            dispatch({
                payload: storedState.setPageLastTickets,
                type: ACTIONS.SET_PAGE_LAST_TICKETS,
            })
        }
    }, [])

    React.useEffect(() => {
        if (state.idList) {
            setLoading(false);
            if (state.idList?.length <= 0) {
                props.setGlobalAlert("No hay número de clientes asociados.", "warning", true, "Advertencia");
            }
        }
    }, [state.idList]);

    React.useEffect(() => {
        setLoading(true);
        dispatch({
            payload: true,
            type: ACTIONS.SET_LOAD_PAGE,
        });

    }, []);

    React.useEffect(() => {
        if (loadingCount + 1 === 2) {
            setLoading(false);
        }
        setLoadingCount(loadingCount + 1);
        const dataTicket = state.resumeTicket;
        const dataHistory = state.historyConsu;

        if (dataTicket) {
            if (dataTicket?.code >= 0) {
                setDataItemTicket(dataTicket);
            } else {
                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
            }
        }

        if (dataHistory) {
            if (dataHistory?.code >= 0) {
                switch (Number(dataHistory?.code)) {
                    case 0:
                        setShowChart(true);
                        setDataChart([]);
                        setLabelsChart([]);

                        if (dataHistory.item.length > 0) {
                            dataHistory.item.forEach(obj => {
                                setDataChart(oldAr => [...oldAr, Number(obj.CONSUMO_KWH)]);
                                setLabelsChart(oldAr => [...oldAr, obj.DIAMES_INI]);
                            })
                        } else {
                            props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
                        }
                        break;
                    default:
                        setShowChart(false);
                        props.setGlobalAlert(dataHistory?.mensaje, "warning");
                        break;
                }
            } else {
                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
            }
        }

    }, [state.historyConsu]);

    React.useEffect(() => {
        if (loadingCount + 1 === 2) {
            setLoading(false);
        }
        setLoadingCount(loadingCount + 1);

        const dataBol = state.responseDoc;

        if (dataBol.code >= 0) {
            if (dataBol.url) {
                setUrlBol(dataBol.boleta);
            }
        }

    }, [state.responseDoc]);

    React.useEffect(() => {
        if (loadingCount === 2) {
            setLoadingCount(0)
        }
    }, [loadingCount]);

    React.useEffect(() => {
        if (state.setPageLastTickets && state.idCtaCto !== 0) {
            setLoading(true)
            LiferayService.getListLastTickets(props.base_url_api, state.idCtaCto, props.qnt_list_boletas, props.codigo_empresa, props.url_ws_empresa)
                .then((tickets) => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 3000);
                    if (tickets.code === 0) {

                        dispatch({
                            payload: tickets,
                            type: ACTIONS.SET_LIST_TICKETS,
                        });
                    } else {
                        if (tickets.message && tickets.status !== 500) {
                            props.setGlobalAlert(tickets.message, "warning", true, "Advertencia");
                        } else if (tickets.status === 500) {
                            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                        }
                    }
                })

        }
    }, [state.setPageLastTickets || state.idCtaCto]);

    React.useEffect(() => {
        if (state.setPageLastTickets && state.idCtaCto !== 0) {
            setLoading(true)
            LiferayService.getListLastTickets(props.base_url_api, state.idCtaCto, props.qnt_list_boletas, props.codigo_empresa, props.url_ws_empresa)
                .then((tickets) => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 3000);
                    if (tickets.code === 0) {

                        dispatch({
                            payload: tickets,
                            type: ACTIONS.SET_LIST_TICKETS,
                        });
                    } else {
                        if (tickets.message && tickets.status !== 500) {
                            props.setGlobalAlert(tickets.message, "warning", true, "Advertencia");
                        } else if (tickets.status === 500) {
                            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                        }
                    }
                })
        }
    }, [state.idCtaCto])

    React.useEffect(() => {
        if (state.listTickets) {
            if (state.listTickets.code === 0) {
                setListTickets(state.listTickets.items)
            }
        }
    }, [state.listTickets])

    function handleClickOpenDoc() {
        if (urlBol !== "") {
            window.open(urlBol, "_blank")
        } else if (!dataItemTicket.ctaCto) {
            props.setGlobalAlert("Debes completar o seleccionar el campo Número de cliente", "warning");
        } else {
            props.setGlobalAlert(decode_utf8(props.text_alert_boleta_indisponible), "warning", true, "Advertencia");
        }
    }

    function handleButtonLastTickets() {
        if (dataItemTicket.ctaCto) {
            dispatch({
                payload: true,
                type: ACTIONS.SET_PAGE_LAST_TICKETS,
            }
            )
        } else if (!dataItemTicket.ctaCto) {
            props.setGlobalAlert("Debes completar o seleccionar el campo Número de cliente", "warning");
        } else {
            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        }
    }

    function handleClickPayHere() {
        if (dataItemTicket.ctaCto) {
            window.location.href = `detalle-de-cuenta-priv?ctacto=${dataItemTicket.ctaCto}`;
        } else {
            props.setGlobalAlert("Debes completar o seleccionar el campo Número de cliente", "warning");
        }
    }

    function handleButtonBackAttachedComponent() {
        dispatch({
            payload: false,
            type: ACTIONS.SET_PAGE_LAST_TICKETS,
        }
        )
    }

    function getDetailTicket(Array) {
        debugger
        let dateEmission = new Date(changeDataFormat(Array[1]));
        let dateLimitEmission = new Date(changeDataFormat(props.last_year_tickets_emission));
        if (dateEmission <= dateLimitEmission) {
            setVisibleModal(true)
        } else {
            setLoading(true)
            LiferayService.getDetailTicketPDF(props.base_url_api, state.idCtaCto, props.url_ws_empresa, props.codigo_empresa, Array[0], getSignedIdStatus(), decode_utf8(props.title_pdf_ticket), Array[1])
                .then((response) => {
                    setLoading(false)
                    if (response.status) {
                        if (response.message && response.status !== 500) {
                            props.setGlobalAlert(response.message, "warning", true, "Advertencia");
                        } else {
                            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                        }
                    } else {
                        response.data.blob().then(blob => {
                            const fileURL = window.URL.createObjectURL(blob);
                            let link = document.createElement('a');
                            link.download = `DetalleFacturacion_${getCurrentTime()}.pdf`;
                            link.href = fileURL;
                            link.click();
                        });
                    }
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_DETAIL_TICKET_PDF,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_RESPONSE_DETAIL_TICKET_PDF,
                    });
                })
        }
    }

    return (
        <div id="debtCurrentOverdue" className="cge-ticket-element">
            <div className="rounded bg-white" >
                <HeaderSearch
                    data={data}
                    setSearch={setInputSearch}
                    setSelected={setInputSelected}
                    idClient={inputSelected}
                    inputSearch={inputSearch}
                />
            </div>
            {!state.setPageLastTickets && <AttachedTicketNetBilling
                props={{ ...props, dataItemTicket, showChart, dataChart, labelsChart, loading, handleClickOpenDoc, handleButtonLastTickets, handleClickPayHere }}
            />}
            {state.setPageLastTickets && <LastTickets props={{ ...props, handleButtonBackAttachedComponent, listTickets, getDetailTicket, state }} />}
            {loading && <Loading />}
            {visibleModal && !loading && (
                <AlertModal
                    titleModal="Advertencia"
                    msgModal={`${props.text_error_last_year_tickets_emission} ${props.last_year_tickets_emission}`}
                    observer={observer}
                    onClose={onClose}
                    status="warning"
                />
            )}
        </div>
    );
};

const AttachedTicketNetBillingControllerWithProvider = ({ props }) => (
    <NetbillingContextProvider>
        <AttachedTicketNetBillingController props={props} />
    </NetbillingContextProvider>
);
export default AttachedTicketNetBillingControllerWithProvider;
